import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { LoginModule } from './authentication/login/login.module';
import { ToastData, ToastOptions, ToastyConfig, ToastyService } from '@haithamsboui/ng-toasty';
import { LayoutModule } from './layout/layout.module';
import { AppRequestInterceptor } from './app.request.interceptor';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { TranslatePipe } from './shared/pipes/translate.pipe';


@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, HttpClientModule, LoginModule, LayoutModule, CoreModule, AppRoutingModule],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    ToastyService,
    TranslatePipe,
    ToastData,
    ToastOptions,
    ToastyConfig,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppRequestInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
